import { isDefined } from '@freelancer/utils';
import type {
  LocationInputCustomCoordinate,
  LocationInputCustomAddress,
  LocationInputMapLocation,
} from './location-input.types';

export function isLocationInputCustomAddress(
  value: any,
): value is LocationInputCustomAddress {
  return value && value.fullAddress;
}

export function isLocationInputCustomCoordinate(
  value: any,
): value is LocationInputCustomCoordinate {
  return (
    value && value.latitude && value.longitude && !value.location && !value.type
  );
}

export function isLocationInputMapLocation(
  value: any,
): value is LocationInputMapLocation {
  return value && value.location && isDefined(value.location);
}
